import type { MutationTree } from 'vuex';
import type { IComment } from '@lib-shared/chat/types/comment';
import type { IChatState } from '@signing-page/chat/store/chat.types';
import { EChatMutation } from '@signing-page/chat/store/chat.constants';

export const mutations: MutationTree<IChatState> = {
  [EChatMutation.SetLoading](state: IChatState, loading: boolean) {
    state.isLoading = loading;
  },
  [EChatMutation.SetChatMessages](state: IChatState, comments: IComment[]) {
    state.comments = comments;
  },
  [EChatMutation.SetIsOpen](state: IChatState, isOpen: boolean) {
    state.isOpen = isOpen;
  },
  [EChatMutation.SetCommentsRead](state: IChatState, commentsRead: IComment[]) {
    state.commentsRead = commentsRead;
  },
  [EChatMutation.SetSystemMessageOpen](state: IChatState, open: boolean) {
    state.systemMessageOpen = open;
  },
};
